module.exports = __webpack_public_path__ + "img/belgium.b29d2a4.webp";